import { Routes, Route, Navigate } from "react-router-dom";
import { lazy, Suspense } from "react";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute";
import LoadingScreen from "./components/LoadingScreen/LoadingScreen";
import disableDevtool from "disable-devtool";

const ResolverOlimpiada = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Olimpiadas/ResolverOlimpiada"));
const RelatorioOlimpiada = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Olimpiadas/RelatorioOlimpiada"));

const Home = lazy(() => import("./views/Home"));
const RecuperarSenha = lazy(() => import("./views/RecuperarSenha"));
const ResetarSenha = lazy(() => import("./views/ResetarSenha"));
const Planos = lazy(() => import("./views/Planos"));
const Assinar = lazy(() => import("./views/Assinar"));
const Presell = lazy(() => import("./views/Presell"));
const Obrigado = lazy(() => import("./views/Obrigado"));
const RenovarPlano = lazy(() => import("./views/RenovarPlano"));
const ContaSuspensa = lazy(() => import("./views/ContaSuspensa"));
const DashboardAluno = lazy(() => import("./views/Dashboard/DashboardAluno"));

/* ENEM (mantido) */
const ResolverEnem = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Resolver/ResolverEnem"));
const GeradorSimulados = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Gerador/GeradorSimulados"));
const RelatorioEnem = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Relatorio/RelatorioEnem"));

/* VESTIBULAR — novas telas (apenas resolver/relatório) */
const ResolverVestibular = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Vestibular/ResolverVestibular"));
const RelatorioVestibular = lazy(() => import("./components/DashboardAluno/AlunoSimulado/Vestibular/RelatorioVestibular"));

// disableDevtool({ md5: true, disableMenu: true });
// if (import.meta.env.PROD) {
//   import("disable-devtool").then(({ default: disableDevtool }) =>
//     disableDevtool({ md5: true, disableMenu: true })
//   );
// }

const Router = () => (
  <Suspense fallback={<LoadingScreen />}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Home />} />

      {/* rotas públicas */}
      <Route path="/recuperar-senha" element={<RecuperarSenha />} />
      <Route path="/resetar-senha" element={<ResetarSenha />} />
      <Route path="/planos" element={<Planos />} />
      <Route path="/assinar" element={<Assinar />} />
      <Route path="/presell/:slug" element={<Presell />} />
      <Route path="/obrigado" element={<Obrigado />} />
      {/* acessível com token válido mesmo quando assinatura expirou */}
      <Route path="/renovar" element={<RenovarPlano />} />
      {/* conta suspensa por instituição — sem token necessário */}
      <Route path="/conta-suspensa" element={<ContaSuspensa />} />
      <Route element={<PrivateRoute />}>
        {/* Dashboard */}
        <Route path="/dashboard" element={<DashboardAluno />} />

        {/* ENEM */}
        <Route path="/aluno/simulado/gerar" element={<GeradorSimulados />} />
        <Route path="/aluno/simulado/enem" element={<ResolverEnem />} />
        <Route path="/aluno/simulado/relatorio" element={<RelatorioEnem />} />

        {/* VESTIBULAR */}
        <Route path="/aluno/vestibular/resolver/:id" element={<ResolverVestibular />} />
        <Route path="/aluno/vestibular/relatorio/:id" element={<RelatorioVestibular />} />

        {/* OLIMPÍADAS */}
        <Route path="/aluno/olimpiada/resolver/:id" element={<ResolverOlimpiada />} />
        <Route path="/aluno/olimpiada/relatorio/:id" element={<RelatorioOlimpiada />} />
      </Route>

      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  </Suspense>
);

export default Router;